import { render } from "./Resale.vue?vue&type=template&id=562eaf02&scoped=true&ts=true"
import script from "./Resale.vue?vue&type=script&lang=ts"
export * from "./Resale.vue?vue&type=script&lang=ts"

import "./Resale.vue?vue&type=style&index=0&id=562eaf02&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562eaf02"]])

export default __exports__